import { createFileRoute } from '@tanstack/react-router';
import { SHEET_TABS } from '@/features/sync/sheetTabConfigs';
import { SyncDetailPage } from '@/features/sync/SyncDetailPage';

export const Route = createFileRoute('/_authenticated/people/sync/$id')({
  component: function PeopleSyncDetail() {
    const { id } = Route.useParams();
    return <SyncDetailPage config={SHEET_TABS.hr} id={id} />;
  },
});
